import { useState } from "react";
import { X } from "lucide-react";

/* Chip-based input: type a value, press Enter or click Add, it pushes into
   the tags array. Each chip has a × to remove. Used in the builders form
   for the locations array and elsewhere for similar list inputs. */
export function TagInput({ tags, setTags, placeholder }) {
  const [val, setVal] = useState("");
  const add = () => {
    const t = val.trim();
    if (t && !tags.includes(t)) setTags([...tags, t]);
    setVal("");
  };
  return (
    <div className="flex flex-wrap items-center gap-1.5 rounded-lg ring-1 ring-inset ring-slate-300 px-2 py-1.5 focus-within:ring-blue-500">
      {tags.map((t) => (
        <span
          key={t}
          className="inline-flex items-center gap-1 text-xs font-medium bg-slate-100 text-slate-700 rounded-md pl-2 pr-1 py-1"
        >
          {t}
          <button
            onClick={() => setTags(tags.filter((x) => x !== t))}
            className="text-slate-400 hover:text-red-600"
          >
            <X className="w-3 h-3" />
          </button>
        </span>
      ))}
      <input
        value={val}
        onChange={(e) => setVal(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            add();
          }
        }}
        onBlur={add}
        placeholder={tags.length ? "" : placeholder}
        className="flex-1 min-w-[100px] text-sm bg-transparent px-1 py-0.5 focus:outline-none"
      />
    </div>
  );
}
